const getAppDomain = (): string =>
  window.location?.hostname?.includes('localhost') ? '' : '.zinia.com';

export { getAppDomain };
